/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import english2x from "components/LandingPage/StudioHero/images/studio-hero-english@2x.webp?responsive";
import german2x from "components/LandingPage/StudioHero/images/studio-hero-german@2x.webp?responsive";
import french2x from "components/LandingPage/StudioHero/images/studio-hero-french@2x.webp?responsive";
import spanish2x from "components/LandingPage/StudioHero/images/studio-hero-spanish@2x.webp?responsive";
import portuguese2x from "components/LandingPage/StudioHero/images/studio-hero-portuguese@2x.webp?responsive";
import italian2x from "components/LandingPage/StudioHero/images/studio-hero-italian@2x.webp?responsive";

export const LandingPageStudioHeroImages: Record<string, { srcSet: string }> = {
  en: {
    srcSet: english2x.srcSet,
  },
  de: {
    srcSet: german2x.src,
  },
  fr: {
    srcSet: french2x.srcSet,
  },
  es: {
    srcSet: spanish2x.src,
  },
  pt: {
    srcSet: portuguese2x.srcSet,
  },
  it: {
    srcSet: italian2x.srcSet,
  },
};
